module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DIV', [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n    403: Доступ запрещен"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/"
    }
  }, [_c('Button', {
    staticClass: "button-primary",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    }
  }, [_vm._v("Перейти на главную")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baaf6462","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommonPages/403PageForbidden.vue
// module id = 366
// module chunks = 0